import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.readonly
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { sm: "3", lg: "3" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        [
                          _c(VSelect, {
                            attrs: {
                              label: _vm.$t("my_tasks.modals.project"),
                              dense: "",
                              outlined: "",
                              disabled: _vm.readonly,
                              items: _vm.projectListDict,
                            },
                            model: {
                              value: _vm.new_table.project_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.new_table, "project_name", $$v)
                              },
                              expression: "new_table.project_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "3", lg: "3" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$t("my_tasks.tablas_tasks.dataset"),
                              dense: "",
                              outlined: "",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.new_table.dataset_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.new_table, "dataset_name", $$v)
                              },
                              expression: "new_table.dataset_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "3", lg: "3" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        [
                          _c(VTextField, {
                            attrs: {
                              label: _vm.$t("my_tasks.tablas_tasks.table"),
                              dense: "",
                              outlined: "",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.new_table.table_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.new_table, "table_name", $$v)
                              },
                              expression: "new_table.table_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "1", lg: "1" } },
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        outlined: "",
                        color: "secondary",
                        small: "",
                        dense: "",
                        rounded: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.odAddTable()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btns.add_item")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        { staticClass: "mb-1" },
        [
          _c(
            VCol,
            { staticClass: "w-full" },
            [
              _c(VDataTable, {
                staticClass: "table-inca",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.item.tables,
                  "hide-default-footer":
                    Object.keys(_vm.item.tables).length <= 10 ? true : false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function (row) {
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteItem(
                                                    row.item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-delete")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("btns.remove_item"))),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.table_name",
                    fn: function (row) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function ($event) {
                                return _vm.onShowTable(row.item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.item.table_name))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }